'use strict';

var ThematicBarChart = function ThematicBarChart(AbstractChart, chartGroups, chartSimpleBars, chartCircles, chartTiles, chartXAxis, chartYAxis, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    var groups = chartGroups('label', formatters.tooltipFormatter, true);
    var m1Bars = chartSimpleBars('m1');
    var m2Bars = chartSimpleBars('m2');
    var tiles = chartTiles('label', 'm2', 'tiles').withHeight(2);
    var circles = chartCircles('circles');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withTextRotation(chartConstants.AXIS.SKEW.DEG_45).withoutLine().withRepetition(1);
    var yAxis = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    this.render = function (data) {
      var length = data.length;
      this.initChart(data, [0, length], chartParams(length));
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForDataGroup([yAxis, groups, m2Bars, m1Bars, tiles, circles, xAxis], this.scales);
    };
    this.withMetric = function (metric) {
      yAxis.label(metric.label);
      return this;
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ThematicBarChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsCircles', 'ChartElementsTiles', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants'];
module.exports = ThematicBarChart;